import { render, staticRenderFns } from "./reservacionesTrans.vue?vue&type=template&id=231a3be0"
import script from "./reservacionesTrans.vue?vue&type=script&lang=js"
export * from "./reservacionesTrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports